import { useState } from "react";
import ui from "./ui.module.css";

// For the adult testing or re-issuing a tablet. Small and out of the way, and
// it asks first, so a learner tapping it by accident loses nothing.
const ResetTablet = ({ onReset }) => {
  const [asking, setAsking] = useState(false);
  const [busy, setBusy] = useState(false);

  const reset = async () => {
    setBusy(true);
    await onReset();
  };

  return (
    <>
      <button type="button" className={ui.textButton} onClick={() => setAsking(true)}>
        Reset tablet
      </button>
      {asking && (
        <div className={ui.sheetBackdrop}>
          <div className={ui.sheet} role="alertdialog" aria-labelledby="reset-title">
            <h2 id="reset-title" className={ui.cardTitle}>
              Reset this tablet?
            </h2>
            <p className={ui.meta}>
              It will need a new setup code from a teacher before it can be used again.
              Work already saved is kept.
            </p>
            <button
              type="button"
              className={`${ui.button} ${ui.primary} ${ui.full}`}
              onClick={reset}
              disabled={busy}
            >
              {busy ? "Resetting…" : "Reset tablet"}
            </button>
            <button
              type="button"
              className={`${ui.button} ${ui.secondary} ${ui.full}`}
              onClick={() => setAsking(false)}
              disabled={busy}
              autoFocus
            >
              Keep it set up
            </button>
          </div>
        </div>
      )}
    </>
  );
};

export default ResetTablet;
